module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "col-xs-12 main",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts appointments"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/campaigns"
    }
  }, [_vm._v("Campaigns")]), _vm._v(" > " + _vm._s(_vm.campaign_name))], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 doc-wrapper"
  }, [_c('div', {
    staticClass: "box panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("1. Find Appointments")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.step3),
      expression: "!step3"
    }],
    staticClass: "col-xs-12 col-lg-10 col-lg-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('FormulateForm', {
    staticClass: "col-xs-12 col-md-2 slots-ui"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('FormulateInput', {
    attrs: {
      "name": "zipcode",
      "type": "text",
      "label": "Zip Code *",
      "error": _vm.findSlotsErrors.zipcode
    },
    model: {
      value: (_vm.zipcode),
      callback: function($$v) {
        _vm.zipcode = $$v
      },
      expression: "zipcode"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "name": "appointment_date",
      "type": "date",
      "label": "Appointment date",
      "error": _vm.findSlotsErrors.desired_date
    },
    model: {
      value: (_vm.desired_date),
      callback: function($$v) {
        _vm.desired_date = $$v
      },
      expression: "desired_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right buttons-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.loadingSlots
    },
    on: {
      "click": _vm.findSlots
    }
  }, [_vm._v("Find Slots")]), _vm._v(" "), (_vm.loadingSlots) ? _c('div', {
    staticClass: "waiting-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('small', [_vm._v("loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.findSlotsErrors.non_field_errors),
      expression: "findSlotsErrors.non_field_errors"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.findSlotsErrors.non_field_errors))])])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.step2 && !_vm.loadingSlots) ? _c('div', {
    staticClass: "col-xs-12 col-md-10 slots-ui"
  }, [(_vm.availableSlots.length) ? _c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Time")]), _vm._v(" "), _vm._l((_vm.tableHeader), function(header) {
    return _c('th', [_vm._v(_vm._s(header))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.slotsByTime), function(slots) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(slots[0]))]), _vm._v(" "), _vm._l((slots.slice(1)), function(slot) {
      return _c('td', [(slot) ? _c('div', {
        staticClass: "col-xs-12 appointment-slot",
        class: {
          selected: slot.selected
        }
      }, [_c('div', {
        staticClass: "appointment-options col-xs-12"
      }, _vm._l((slot.appointment_types), function(slots_per_type) {
        return _c('button', {
          staticClass: "btn",
          class: _vm.appointmentTypeButton[slots_per_type.appointment_type],
          attrs: {
            "title": _vm.appointmentTypeOptions[slots_per_type.appointment_type],
            "disabled": slot.selected && slot.appointment_type == slots_per_type.appointment_type
          },
          on: {
            "click": function($event) {
              return _vm.selectSlot(slot, slots_per_type)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-lg",
          class: _vm.appointmentTypeIcons[slots_per_type.appointment_type]
        })])
      }), 0)]) : _vm._e()])
    })], 2)
  }), 0)]) : _c('div', {
    staticClass: "no-slots"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("No slots available")]), _vm._v(" "), _c('p', [_vm._v("\n                            No licensed agents available in this zip code.\n                          ")])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.availableSlots.length) ? _c('div', {
    staticClass: "col-md-offset-2 col-md-10 col-xs-12 text-right slots-ui buttons-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.selectedSlot || _vm.confirmingSelection
    },
    on: {
      "click": _vm.bookAppointment
    }
  }, [_vm._v("Confirm Selection")]), _vm._v(" "), (_vm.confirmingSelection) ? _c('div', {
    staticClass: "waiting-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('small', [_vm._v("loading...")])]) : _vm._e()]) : _vm._e()])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 doc-wrapper"
  }, [_c('div', {
    staticClass: "box panel step3"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("2. Appointment Information")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step3),
      expression: "step3"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.bookedAppointment) ? _c('div', {
    staticClass: "col-xs-12 col-lg-6 col-lg-offset-3"
  }, [_c('h3', [_vm._v("Selected Appointment")]), _vm._v(" "), _c('div', {
    staticClass: "well text-danger"
  }, [_c('i', {
    staticClass: "fa fa-warning fg-2x"
  }), _vm._v(" "), _c('strong', [_vm._v("Appointments must be sent within " + _vm._s(_vm.bookedAppointment.blocked_period) + " minutes or they will expire")])]), _vm._v(" "), _c('table', {
    staticClass: "table col-xs-12"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.bookedAppointment.id))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.copyAppointmentId()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  }), _vm._v(" Copy")]), _vm._v(" "), (_vm.copyFeedback) ? _c('span', {
    staticClass: "copied-feedback"
  }) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Company")]), _c('td', [_vm._v(_vm._s(_vm.bookedAppointment.agent.agency))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Appointment Type")]), _c('td', [_vm._v(_vm._s(_vm.appointmentTypeOptions[_vm.bookedAppointment.appointment_type]))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Appointment Date")]), _c('td', [_vm._v(_vm._s(_vm.bookedAppointmentStartTime))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Agent Name")]), _c('td', [_vm._v(_vm._s(_vm.bookedAppointment.agent.name))])]), _vm._v(" "), _c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-at"
  }), _vm._v(" Agent Email")]), _c('td', [_vm._v(_vm._s(_vm.bookedAppointment.agent.email))])]), _vm._v(" "), _c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" Agent Phone")]), _c('td', [_vm._v(_vm._s(_vm.bookedAppointment.agent.phone))])]), _vm._v(" "), (_vm.bookedAppointment.agent.office_address && _vm.bookedAppointment.appointment_type == 'in-person-at-office') ? _c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Office Address")]), _c('td', [_vm._v(_vm._s(_vm.bookedAppointment.agent.office_address))])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6 col-lg-offset-3 submit text-right buttons-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.loadingSlots
    },
    on: {
      "click": _vm.cancelAppointment
    }
  }, [_vm._v("Cancel & Back")]), _vm._v(" "), (_vm.loadingSlots) ? _c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('small', [_vm._v("loading...")])]) : _vm._e()])])])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.appointmentIdCopied) ? _c('div', {
    staticClass: "col-xs-12 doc-wrapper text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.loadingSlots
    },
    on: {
      "click": _vm.restart
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o"
  }), _vm._v(" New Appointment")])]) : _vm._e()])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f48b9c88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/CampaignForm.vue
// module id = 679
// module chunks = 0